import { useEffect } from "react";
import { SocketProvider } from "./context/SocketContext";
import { TwitchProvider } from "./context/TwitchContext";
import { useOverlayState } from "./hooks/useOverlayState";
import CardGame from "./components/CardGame";
import ObsMask from "./components/obs-mask";
import AlertBox from "./components/alert-box";
import RareOpenAlert from "./components/rare_open";
import Giveaway from "./components/giveaway";
import { RightPanel, MidBar, BottomBar } from "./components/layout";

function OverlayContent() {
  const {
    greenScreen,
    topEspont,
    banner,
    rareOpenData,
    midbar,
    showWheel,
    profiles,
    currentWinner,
    participants,
    participantBoosts,
    keyword,
    removeNyWinner,
    gwTimer,
    espont,
    activeSite,
    nyeremenyJatekData,
    activeContest,
    startOverlay,
    handleAnimationComplete,
    cardGame,
  } = useOverlayState();

  // Initialize overlay on mount
  useEffect(() => {
    startOverlay();
  }, [startOverlay]);

  // Site animation interval
  useEffect(() => {
    const site = document.querySelector(".currently-playing .kaszi");
    if (!site) return;

    const toggleActiveState = () => {
      site.classList.add("active");
      setTimeout(() => {
        site.classList.remove("active");
      }, 8000);
    };

    toggleActiveState();
    const timer = setInterval(toggleActiveState, 28000);

    return () => clearInterval(timer);
  }, []);

  // Announcement rotation
  useEffect(() => {
    const ann = document.querySelector(".announcements img");
    if (!ann) return;

    let counter = 1;
    const timer = setInterval(() => {
      ann.style.opacity = 0;
      setTimeout(() => {
        ann.src = `/announcements/${counter}.png`;
        ann.style.opacity = 1;
        counter = counter === 2 ? 1 : counter + 1;
      }, 500);
    }, 30000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <div className="main-overlay w-[1920px] h-[1080px] px-6 pb-3 pt-10 text-white font-sans">
        <ObsMask isGreenScreen={greenScreen} />
        {/* A kartyajatek a KEPERNYO celljaban el, nem a teljes 1920x1080-on:
            a .screen doboz a monitor helye, a jatek ezt tolti ki. */}
        <div className="screen rounded-3xl relative overflow-hidden">
          <CardGame state={cardGame} />
        </div>

        <RightPanel
          greenScreen={greenScreen}
          activeContest={activeContest}
          participants={participants}
          participantBoosts={participantBoosts}
          keyword={keyword}
          nyeremenyJatekData={nyeremenyJatekData}
          removeNyWinner={removeNyWinner}
          gwTimer={gwTimer}
        />

        <MidBar midbar={midbar} activeSite={activeSite} banner={banner} />

        <BottomBar topEspont={topEspont} espont={espont} />
      </div>

      {showWheel && currentWinner && profiles?.length > 0 && (
        <Giveaway
          key={currentWinner.id}
          showWheel={showWheel}
          profiles={profiles}
          winnerr={currentWinner}
          onAnimationComplete={handleAnimationComplete}
        />
      )}
      {rareOpenData && <RareOpenAlert data={rareOpenData} />}
      <AlertBox />
    </>
  );
}

export default function App() {
  return (
    <SocketProvider>
      <TwitchProvider>
        <OverlayContent />
      </TwitchProvider>
    </SocketProvider>
  );
}
